import Repository from './Repository'

const resource = 'person'

export default {
  createPerson (userId, data) {
    return Repository.post(`users/${userId}/${resource}`, data)
  },
  updatePerson (userId, personId, data) {
    return Repository.patch(`users/${userId}/${resource}/${personId}`, data)
  }
}
